const PDF_SESSION_ENDPOINT = '/mini-calculator/pdf-session'

function readCsrfToken() {
    if (typeof document === 'undefined') return ''
    const el = document.querySelector('meta[name="csrf-token"]')
    return el ? el.getAttribute('content') || '' : ''
}

export async function postPdfSession({ inputs, calculations, locale, captchaToken }) {
    const body = {
        ...(inputs || {}),
        ...(calculations || {}),
        locale,
        'g-recaptcha-response': captchaToken,
    }

    const res = await fetch(PDF_SESSION_ENDPOINT, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'X-CSRF-TOKEN': readCsrfToken(),
            'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify(body),
    })

    if (!res.ok) {
        throw new Error(`pdf-session POST failed with status ${res.status}`)
    }

    return res.json()
}
